import { useSearchParams } from 'react-router-dom'
import { Button } from 'reactstrap'
import { FaBackward, FaForward } from 'react-icons/fa'
import { gql } from '@apollo/client'
import { SET_USER_ATTRIBUTE_MUTATION } from '../../graphql'
import './Pagination.css'

export const USER_ATTRIBUTE_MUTATION = gql(SET_USER_ATTRIBUTE_MUTATION)

export default function PaginationPageControls(props) {
  const { results } = props
  console.log('PaginationPageControls rendered:', props)

  const [searchParams, setSearchParams] = useSearchParams()

  let start = parseInt(results.start)

  function changeStart(newStart) {
    const currentParams = Object.fromEntries([...searchParams])
    currentParams.start = newStart
    setSearchParams(currentParams)
  }

  function nextClicked() {
    console.log('PaginationPageControls.nextClicked')
    const newStart = start + parseInt(results.recordsDisplayed)
    changeStart(newStart)
  }

  function previousClicked() {
    console.log('PaginationPageControls.previousClicked')
    const newStart = start - parseInt(results.recordsDisplayed) <= 0 ? 1 : start - parseInt(results.recordsDisplayed)
    changeStart(newStart)
  }

  // page control section
  let pageControls = null
  if (results.totalRecordsFound > results.recordsDisplayed) {
    const previousDisabled = start > 1 ? false : true
    const nextDisabled = (start + results.recordsDisplayed - 1) < results.totalRecordsFound ? false : true
    pageControls =
      <div className="pagination-page-control-container">
        <Button data-cy="pagination-page-button-prev" className="pagination-page-button" disabled={previousDisabled} onClick={previousClicked}><FaBackward /> Prev</Button>
        <Button data-cy="pagination-page-button-next" className="pagination-page-button pagination-next-button" disabled={nextDisabled} onClick={nextClicked}>Next <FaForward /></Button>
      </div>
  }

  return pageControls
}